import {useEffect, useState} from "react";
import * as CrudServices from '../../../../service/crudServices';
import * as RegionalServices from '../../../../service/RegionalServices';
import {API_COMPANY_PROFILE} from "../../../../api/contractAPI.api";
import {useDispatch, useSelector} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";
import {ROUTES} from "../../../../constant/routeConstant";
import checkPhoneForEdit from "../../../../helpers/checkPhoneForEdit";
import {onChanged} from "../../../../util/Util";
import validationCompanyProfile from "../validationCompanyProfile";
import {t} from "i18next";
import {validateSubmit} from "../../../../util";

const useEditCompanyProfile = () => {
    const {token} = useSelector((state) => state.auth);
    const _ = require('lodash')

    // React Hooks const
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch()

    // Data Processing
    const [detail, setDetail] = useState({});
    const [listCountry, setListCountry] = useState([]);
    const [listProvince, setListProvince] = useState([]);
    const [listDistrict, setListDistrict] = useState([]);
    const [listSubDistrict, setListSubDistrict] = useState([]);
    const [listUrbanVillage, setListUrbanVillage] = useState([]);
    const [listPostalCode, setListPostalCode] = useState([]);
    const [fileImg, setFileImg] = useState([]);

    // Modals
    const [modalFailed, setModalFailed] = useState(false);
    const [messageModalFailed, setMessageModalFailed] = useState('');
    const [modalSuccess, setModalSuccess] = useState(false);

    // Error Handling
    const [error, setError] = useState([]);
    const [err, setErr] = useState("");

    // Form
    const [form, setForm] = useState({});

    // Pages Settings
    const [isChanged, setIsChanged] = useState(false)

    // DDS States
    const [countryKeyword, setCountryKeyword] = useState('')
    const [countryListPage, setCountryListPage] = useState(1)

    const [provinceKeyword, setProvinceKeyword] = useState('')
    const [provinceListPage, setProvinceListPage] = useState(1)

    const [districtKeyword, setDistrictKeyword] = useState('')
    const [districtListPage, setDistrictListPage] = useState(1)

    const [subDistrictKeyword, setSubDistrictKeyword] = useState('')
    const [subDistrictListPage, setSubDistrictListPage] = useState(1)

    const [urbanVillageKeyword, setUrbanVillageKeyword] = useState('')
    const [urbanVillageListPage, setUrbanVillageListPage] = useState(1)

    const [postalCodeKeyword, setPostalCodeKeyword] = useState('')
    const [postalCodeListPage, setPostalCodeListPage] = useState(1)

    const [dropdownListLoading, setDropdownListLoading] = useState(false)
    const [userManagementOpen, setUserManagementOpen] = useState(false)

    // Inquiry Data
    const getDetail = async (id) => {
        const {ok, data} = await CrudServices.getDetail(token, API_COMPANY_PROFILE, id);
        if (ok && data) {
            setDetail(data);
            setForm(data);
        }
    }

    const onSearchDDS = (keyword, from) => {
        switch (from) {
            case 'company_country_id':
                setCountryKeyword(keyword)
                if (keyword.length >= 3 || keyword === '') {
                    getListCountry(1, keyword, 'searchList')
                }
                setCountryListPage(1)
                break;
            case 'company_province_id':
                setProvinceKeyword(keyword)
                if (keyword.length >= 3 || keyword === '') {
                    getListProvince(1, form.company_country_id, keyword, 'searchList')
                }
                setProvinceListPage(1)
                break;
            case 'company_district_id':
                setDistrictKeyword(keyword)
                if (keyword.length >= 3 || keyword === '') {
                    getListDistrict(1, form.company_country_id, form.company_province_id, keyword, 'searchList')
                }
                setDistrictListPage(1)
                break;
            case 'company_sub_district_id':
                setSubDistrictKeyword(keyword)
                if (keyword.length >= 3 || keyword === '') {
                    getListSubDistrict(1, form.company_country_id, form.company_district_id, keyword, 'searchList')
                }
                setSubDistrictListPage(1)
                break;
            case 'company_urban_village_id':
                setUrbanVillageKeyword(keyword)
                if (keyword.length >= 3 || keyword === '') {
                    getListUrbanVillage(1, form.company_country_id, form.company_sub_district_id, keyword, 'searchList')
                }
                setUrbanVillageListPage(1)
                break;
            case 'company_postal_code_id':
                setPostalCodeKeyword(keyword)
                if (keyword.length >= 3 || keyword === '') {
                    getListPostalCode(1, form.urban_village, keyword, 'searchList')
                }
                setPostalCodeListPage(1)
                break;
            default:
                break;
        }
    }

    const onScroll = (event, namespace, depot_id) => {
        let target = event.target;
        switch (namespace) {
            case 'company_country_id':
                if (target.scrollHeight - Math.ceil(target.scrollTop) === target.clientHeight || (target.scrollHeight - Math.ceil(target.scrollTop) === target.clientHeight + 1) && !dropdownListLoading) {
                    getListCountry(countryListPage + 1, 10)
                    setCountryListPage(countryListPage + 1)
                    target.scrollTo(0, target.scrollHeight);
                }
                break;
            case 'company_province_id':
                if (target.scrollHeight - Math.ceil(target.scrollTop) === target.clientHeight || (target.scrollHeight - Math.ceil(target.scrollTop) === target.clientHeight + 1) && !dropdownListLoading) {
                    getListProvince(provinceListPage + 1, form.company_country_id)
                    setProvinceListPage(provinceListPage + 1)
                    target.scrollTo(0, target.scrollHeight);
                }
                break;
            case 'company_district_id':
                if (target.scrollHeight - Math.ceil(target.scrollTop) === target.clientHeight || (target.scrollHeight - Math.ceil(target.scrollTop) === target.clientHeight + 1) && !dropdownListLoading) {
                    getListDistrict(districtListPage + 1, form.company_country_id, form.company_province_id)
                    setDistrictListPage(districtListPage + 1)
                    target.scrollTo(0, target.scrollHeight);
                }
                break;
            case 'company_sub_district_id':
                if (target.scrollHeight - Math.ceil(target.scrollTop) === target.clientHeight || (target.scrollHeight - Math.ceil(target.scrollTop) === target.clientHeight + 1) && !dropdownListLoading) {
                    getListSubDistrict(subDistrictListPage + 1, form.company_country_id, form.company_district_id)
                    setSubDistrictListPage(subDistrictListPage + 1)
                    target.scrollTo(0, target.scrollHeight);
                }
                break;
            case 'company_urban_village_id':
                if (target.scrollHeight - Math.ceil(target.scrollTop) === target.clientHeight || (target.scrollHeight - Math.ceil(target.scrollTop) === target.clientHeight + 1) && !dropdownListLoading) {
                    getListUrbanVillage(urbanVillageListPage + 1, form.company_country_id, form.company_sub_district_id)
                    setUrbanVillageListPage(urbanVillageListPage + 1)
                    target.scrollTo(0, target.scrollHeight);
                }
                break;
            case 'company_postal_code_id':
                if (target.scrollHeight - Math.ceil(target.scrollTop) === target.clientHeight || (target.scrollHeight - Math.ceil(target.scrollTop) === target.clientHeight + 1) && !dropdownListLoading) {
                    getListPostalCode(postalCodeListPage + 1, form.urban_village)
                    setPostalCodeListPage(postalCodeListPage + 1)
                    target.scrollTo(0, target.scrollHeight);
                }
                break;


            default:
                break;
        }
    }

    // Use Effect inquiry data
    useEffect(() => {
        getDetail(location?.state);
    }, []);

    useEffect(() => {
        if (!_.isEmpty(detail)) {
            getListCountry(countryListPage)
            getListProvince(provinceListPage, detail.company_country_id)
            getListDistrict(districtListPage, detail.company_country_id, detail.company_province_id)
            getListSubDistrict(subDistrictListPage, detail.company_country_id, detail.company_district_id)
            getListUrbanVillage(urbanVillageListPage, detail.company_country_id, detail.company_sub_district_id)
            getListPostalCode(postalCodeListPage, detail.company_urban_village_id)
        }
    }, [detail])

    const getListCountry = async (page, keyword = '', flag = 'list') => {
        setDropdownListLoading(true)
        const params = {page, limit: 10, filter: keyword !== '' ? `name lk ${keyword}` : ''};
        const {ok, list} = await RegionalServices.dropdownCountry(token, params);

        if (ok && list !== null) {
            if (flag === 'list' || flag === 'changed') {
                if (listCountry.length === 0 || flag === 'changed') {
                    const newList = list.map((item) => ({id: item.id, value: item.name}))
                    setListCountry(newList)
                } else {
                    let tempCountryList = [...listCountry]
                    list.map(item => tempCountryList.push({id: item.id, value: item.name}))
                    setListCountry(tempCountryList)
                }
                setDropdownListLoading(false)
            } else if (flag === 'searchList') {
                setListCountry(list.map((item) => ({id: item.id, value: item.name})))
            }
        }
    }

    const getListProvince = async (page, country_id, keyword = '', flag = 'list') => {
        setDropdownListLoading(true)
        const params = {
            page,
            limit: 10,
            filter: keyword !== '' ? `country_id eq ${country_id}, name lk ${keyword}` : `country_id eq ${country_id}`
        };
        const {ok, list} = await RegionalServices.dropdownProvince(token, params);

        if (ok && list !== null) {
            if (flag === 'list' || flag === 'changed') {
                if (listProvince.length === 0 || flag === 'changed') {
                    const newList = list.map((item) => ({id: item.id, value: item.name}))
                    setListProvince(newList);
                } else {
                    let tempProvinceList = [...listProvince]
                    list.map(item => tempProvinceList.push({id: item.id, value: item.name}))
                    setListProvince(tempProvinceList)
                }
                setDropdownListLoading(false)
            } else if (flag === 'searchList') {
                setListProvince(list.map((item) => ({id: item.id, value: item.name})))
            }
        }
    }

    const getListDistrict = async (page, country_id, province_id, keyword = '', flag = 'list') => {
        setDropdownListLoading(true)
        const params = {
            page,
            limit: 10,
            filter: keyword !== '' ? `country_id eq ${country_id}, province_id eq ${province_id}, name lk ${keyword}` : `country_id eq ${country_id}, province_id eq ${province_id}`
        };
        const {ok, list} = await RegionalServices.dropdownDistrict(token, params);

        if (ok && list !== null) {
            if (flag === 'list' || flag === 'changed') {
                if (listDistrict.length === 0 || flag === 'changed') {
                    const newList = list.map((item) => ({id: item.id, value: item.name}))
                    setListDistrict(newList);
                } else {
                    let tempListDistrict = [...listDistrict]
                    list.map(item => tempListDistrict.push({id: item.id, value: item.name}))
                    setListDistrict(tempListDistrict)
                }
                setDropdownListLoading(false)
            } else if (flag === 'searchList') {
                setListDistrict(list.map((item) => ({id: item.id, value: item.name})))
            }
        }
    }

    const getListSubDistrict = async (page, country_id, district_id, keyword = '', flag = 'list') => {
        setDropdownListLoading(true)
        const params = {
            page,
            limit: 10,
            filter: keyword !== '' ? `country_id eq ${country_id}, district_id eq ${district_id}, name lk ${keyword}` : `country_id eq ${country_id}, district_id eq ${district_id}`
        };
        const {ok, list} = await RegionalServices.dropdownSubDistrict(token, params);

        if (ok && list !== null) {
            if (flag === 'list' || flag === 'changed') {
                if (listSubDistrict.length === 0 || flag === 'changed') {
                    const newList = list.map((item) => ({id: item.id, value: item.name}))
                    setListSubDistrict(newList);
                } else {
                    let tempListSubDistrict = [...listSubDistrict]
                    list.map(item => tempListSubDistrict.push({id: item.id, value: item.name}))
                    setListSubDistrict(tempListSubDistrict)
                }
                setDropdownListLoading(false)
            } else if (flag === 'searchList') {
                setListSubDistrict(list.map((item) => ({id: item.id, value: item.name})))
            }
        }
    }

    const getListUrbanVillage = async (page, country_id, sub_district_id, keyword = '', flag = 'list') => {
        setDropdownListLoading(true)
        const params = {
            page,
            limit: 10,
            filter: keyword !== '' ? `country_id eq ${country_id}, sub_district_id eq ${sub_district_id}, name lk ${keyword}` : `country_id eq ${country_id}, sub_district_id eq ${sub_district_id}`
        };
        const {ok, list} = await RegionalServices.dropdownUrbanVillage(token, params);

        if (ok && list !== null) {
            const newList = list.map((item) => {
                return {label: item.name, value: item.id}
            });
            setListUrbanVillage(newList)

            if (flag === 'list' || flag === 'changed') {
                if (listUrbanVillage.length === 0 || flag === 'changed') {
                    const newList = list.map((item) => ({id: item.id, value: item.name}))
                    setListUrbanVillage(newList);
                } else {
                    let tempListUrbanVillage = [...listUrbanVillage]
                    list.map(item => tempListUrbanVillage.push({id: item.id, value: item.name}))
                    setListUrbanVillage(tempListUrbanVillage)
                }
                setDropdownListLoading(false)
            } else if (flag === 'searchList') {
                setListUrbanVillage(list.map((item) => ({id: item.id, value: item.name})))
            }
        }
    }

    const getListPostalCode = async (page, urban_village_id, keyword = '', flag = 'list') => {
        setDropdownListLoading(true)
        const params = {
            page,
            limit: 10,
            filter: keyword !== '' ? `urban_village_id eq ${urban_village_id}, code lk ${keyword}` : `urban_village_id eq ${urban_village_id}`
        };
        const {ok, list} = await RegionalServices.dropdownPostalCode(token, params);

        if (ok && list !== null) {
            if (flag === 'list' || flag === 'changed') {
                if (listPostalCode.length === 0 || flag === 'changed') {
                    const newList = list.map((item) => ({id: item.id, value: item.code}))
                    setListPostalCode(newList);
                } else {
                    let tempListPostalCode = [...listPostalCode]
                    list.map(item => tempListPostalCode.push({id: item.id, value: item.code}))
                    setListPostalCode(tempListPostalCode)
                }
                setDropdownListLoading(false)
            } else if (flag === 'searchList') {
                setListPostalCode(list.map((item) => ({id: item.id, value: item.code})))
            }
        }
    }

    const onChangeSelect = (namespace, evt) => {
        setErr("");
        let errorSelect = validationCompanyProfile(namespace, evt, t);

        onChanged(dispatch, true);
        setIsChanged(true);

        if (namespace === "company_country_id") {
            setForm((prevsValue) => {
                return {
                    ...prevsValue,
                    [namespace]: evt,
                    company_province_id: null,
                    company_district_id: null,
                    company_sub_district_id: null,
                    company_urban_village_id: null,
                    company_postal_code: null,
                    longitude: null,
                    latitude: null
                };
            });

            setListProvince([])
            setListDistrict([])
            setListSubDistrict([])
            setListUrbanVillage([])
            setListPostalCode([])

            getListProvince(provinceListPage, evt, '', 'changed')

        } else if (namespace === "company_province_id") {
            setForm((prevsValue) => {
                return {
                    ...prevsValue,
                    [namespace]: evt,
                    company_district_id: null,
                    company_sub_district_id: null,
                    company_urban_village_id: null,
                    company_postal_code: null,
                    longitude: null,
                    latitude: null
                };
            });

            setListDistrict([])
            setListSubDistrict([])
            setListUrbanVillage([])
            setListPostalCode([])

            getListDistrict(districtListPage, form.company_country_id, evt, '', 'changed')

        } else if (namespace === "company_district_id") {
            setForm((prevsValue) => {
                return {
                    ...prevsValue,
                    [namespace]: evt,
                    company_sub_district_id: null,
                    company_urban_village_id: null,
                    company_postal_code: null,
                    longitude: null,
                    latitude: null
                };
            });

            setListSubDistrict([])
            setListUrbanVillage([])
            setListPostalCode([])

            getListSubDistrict(districtListPage, form.company_country_id, evt, '', 'changed')

        } else if (namespace === "company_sub_district_id") {
            setForm((prevsValue) => {
                return {
                    ...prevsValue,
                    [namespace]: evt,
                    company_urban_village_id: null,
                    company_postal_code: null,
                    longitude: null,
                    latitude: null
                };
            });

            setListUrbanVillage([])
            setListPostalCode([])

            getListUrbanVillage(urbanVillageListPage, form.company_country_id, evt, '', 'changed')

        } else if (namespace === "company_urban_village_id") {
            setForm((prevsValue) => {
                return {
                    ...prevsValue,
                    [namespace]: evt,
                    company_postal_code: null,
                    longitude: null,
                    latitude: null
                };
            });

            setListPostalCode([])

            getListPostalCode(postalCodeListPage, evt, '', 'changed')

        } else {
            setForm((prevsValue) => {
                return {
                    ...prevsValue,
                    [namespace]: evt,
                };
            });
        }

        setError({...error, ...errorSelect});
    }

    const _onChange = (namespace, evt) => {
        setErr("");
        let errorInput = validationCompanyProfile(namespace, evt.target.value, t);

        onChanged(dispatch, true);
        setIsChanged(true);

        setForm((prevsValue) => {
            return {
                ...prevsValue,
                [namespace]: evt.target.value,
            };
        });
        if(namespace==="bank_name" && !evt.target.value){
            setForm((prevsValue) => {
                return {
                    ...prevsValue,
                    ["bank_account_number"]: "",
                };
            });
        }
        setError({...error, ...errorInput});
    }

    const _actionSave = async () => {
        const formData = new FormData();
        let errors = {};

        const payload = {
            company_title: form?.company_title,
            company_name: form?.company_name,
            company_email: form?.company_email,
            company_phone: `+62-${checkPhoneForEdit(form?.company_phone)}`,
            company_fax: form?.company_fax,
            company_npwp: form?.company_npwp.replace(/[.-]/g, ''),
            company_country_id: form?.company_country_id,
            company_island_id: form?.company_island_id,
            company_province_id: form?.company_province_id,
            company_district_id: form?.company_district_id,
            company_sub_district_id: form?.company_sub_district_id,
            company_urban_village_id: form?.company_urban_village_id,
            company_address_1: form?.company_address_1,
            company_address_2: form?.company_address_2,
            company_address_3: form?.company_address_3,
            company_neighbour: form?.company_neighbour,
            company_hamlet: form?.company_hamlet,
            company_postal_code_id: form?.company_postal_code_id,
            company_longitude: form?.longitude,
            company_latitude: form?.latitude,
            company_logo: form?.company_logo,
            updated_at: form?.updated_at,
            bank_account_number :form?.bank_account_number,
            bank_name :form?.bank_name
        }

        const keys = {
            company_title: form?.company_title,
            company_name: form?.company_name,
            company_email: form?.company_email,
            company_phone: checkPhoneForEdit(form?.company_phone),
            company_fax: checkPhoneForEdit(form?.company_fax),
            company_npwp: form?.company_npwp.replace(/[.-]/g, ''),
            company_country_id: form?.company_country_id,
            company_island_id: form?.company_island_id,
            company_province_id: form?.company_province_id,
            company_district_id: form?.company_district_id,
            company_sub_district_id: form?.company_sub_district_id,
            company_urban_village_id: form?.company_urban_village_id,
            company_address_1: form?.company_address_1,
            company_address_2: form?.company_address_2,
            company_address_3: form?.company_address_3,
            company_neighbour: form?.company_neighbour,
            company_hamlet: form?.company_hamlet,
            company_postal_code_id: form?.company_postal_code_id,
            company_longitude: form?.longitude,
            company_latitude: form?.latitude,
            bank_account_number :form?.bank_account_number,
            bank_name :form?.bank_name
        }

        for (const key in keys) {
            const option = validationCompanyProfile(key, keys[key], t);
            const currentError = option;
            errors = {...currentError, ...errors};
        }
        setError(errors);
        if (validateSubmit(errors)) {
            const logos = typeof fileImg === 'string' ? fileImg : typeof fileImg === 'object' && fileImg.length > 0 ? fileImg[0]?.originFileObj : null;

            formData.append('company_profile', JSON.stringify(payload));
            formData.append('company_profile_logo', logos);

            const {status, message} = await CrudServices.updateData(token, form?.company_profile_id, formData);
            if (status) {
                setModalSuccess(true);
            } else {
                setModalFailed(true);
                setMessageModalFailed(message);
            }
        } else {
            setError(errors)
        }
    }

    const _actionOk = () => {
        setModalSuccess(false);
        navigate(ROUTES.COMPANY_PROFILE.DETAIL);
    }

    const backToDetail = () => {
        navigate(ROUTES.COMPANY_PROFILE.DETAIL);
    }

    const clearCurrImg = () => {
        setForm((prevsValue) => {
            return {
                ...prevsValue,
                company_logo: '',
            };
        });
        setFileImg([]);
    }

    const convertTimestamp = (timestamp, isSpecific) => {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        const monthNumbers = ["01", "02", "03", "04", "05", "06",
            "07", "08", "09", "10", "11", "12"
        ];

        // Extract components from the timestamp string
        const year = timestamp?.substring(0, 4);
        const month = timestamp?.substring(5, 7) - 1; // Months in JavaScript are 0-indexed
        const day = timestamp?.substring(8, 10);

        let dateFormat = new Date(year, month, day);

        if (isSpecific) {
            return (`${dateFormat.getDate()}-${monthNames[dateFormat.getMonth()]}-${dateFormat.getFullYear()}`)
        } else {
            return (`${dateFormat.getDate()}/${monthNumbers[dateFormat.getMonth()]}/${dateFormat.getFullYear()}`)
        }
    };

    return {
        detail,
        listCountry,
        listProvince,
        form,
        listDistrict,
        listSubDistrict,
        listUrbanVillage,
        listPostalCode,
        fileImg,
        modalFailed,
        modalSuccess,
        messageModalFailed,
        err,
        error,
        isChanged,
        onChangeSelect,
        _actionSave,
        _onChange,
        backToDetail,
        setFileImg,
        clearCurrImg,
        setModalSuccess,
        setModalFailed,
        _actionOk,
        setErr,
        setError,
        onScroll,
        onSearchDDS,
        countryKeyword,
        provinceKeyword,
        districtKeyword,
        subDistrictKeyword,
        urbanVillageKeyword,
        postalCodeKeyword,
        dropdownListLoading,
        userManagementOpen,
        setUserManagementOpen,
        convertTimestamp
    }
}

export default useEditCompanyProfile;